module.exports = __webpack_public_path__ + "media/images/products/banners/bolsa_3.0-01e58b74c30b2962589d8fbd64bed5ee.png";